import { render } from "./TutoGame.vue?vue&type=template&id=6dc32186"
import script from "./TutoGame.vue?vue&type=script&lang=js"
export * from "./TutoGame.vue?vue&type=script&lang=js"

import "./TutoGame.vue?vue&type=style&index=0&id=6dc32186&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__